<script setup>
import SideFilter from '../SideFilter.vue'

import useWeekDateFilter from '@/utils/useWeekDateFilter'
import { DATE_END_STR, DATE_START_STR } from '@/constants/general'
import { useStore } from '@/utils/VuexHelpers'
import { computed, ref } from 'vue'

const transpSideFilter = ref(null)

const store = useStore()
const filtersTransp = computed(() => store.getters.filtersTransp)

const { updateDateFilter } = useWeekDateFilter(
  'filtersTransp',
  'SET_FILTER_TRANSP'
)

const updateFilter = (payload) => {
  let { value, field } = payload

  if (field === 'delivery_by' && value) {
    store.commit('SET_FREIGHT_FILTER_INFO', value)
    value = value.name
  }
  if (field === DATE_START_STR || field === DATE_END_STR) {
    updateDateFilter({ value, field })
  } else {
    store.commit('SET_FILTER_TRANSP', { value, field })
  }
  store.dispatch('fetchTransport')
}

const updateWeekFilter = (dateRange) => {
  const { weekNr, startDay, endDay, year } = dateRange

  store.commit('SET_FILTER_TRANSP', { field: 'week', value: weekNr })
  store.commit('SET_FILTER_TRANSP', {
    field: 'date_start',
    value: startDay
  })
  store.commit('SET_FILTER_TRANSP', { field: 'date_end', value: endDay })

  if (filtersTransp.value.year.value !== year) {
    store.commit('SET_FILTER_TRANSP', { field: 'year', value: year })
  }
  store.dispatch('fetchTransport')
}
const updateYearFilter = (data) => {
  const { year } = data
  const cleanYear = parseInt(year.trim())

  if (cleanYear === filtersTransp.value.year.value) return

  store.commit('SET_FILTER_TRANSP', { field: 'year', value: cleanYear })
  if (!filtersTransp.value.week.value) return

  transpSideFilter.value.generateWeekDays(
    filtersTransp.value.week.value,
    cleanYear
  )
}
const resetFilters = () => {
  store.dispatch('clearFiltersTransp')
  store.dispatch('fetchTransport')
}
</script>

<template>
  <SideFilter
    ref="transpSideFilter"
    class="mt-0"
    :filter-list="filtersTransp"
    @input="updateFilter"
    @inputWeek="updateWeekFilter"
    @inputYear="updateYearFilter"
    @clear="resetFilters"
  />
</template>
